import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { GeneralService } from 'src/app/services/general.service';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormRs009Filter } from 'src/app/entity/models/form-rs009-filter';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { GeneralFilterComponent } from 'src/app/shared/general-filter.component';

@Component({
    selector: 'app-form-rs009-filter',
    templateUrl: './form-rs009-filter.component.html',
    styleUrls: ['./form-rs009-filter.component.scss']
})
export class FormRs009FilterComponent extends GeneralFilterComponent implements OnInit {

    public formulario?: FormGroup;
    public listProduto?: DropDownListDTO[];
    public listSiteRecebimento?: DropDownListDTO[];
    public listStatus?: DropDownListDTO[];
    public listSafra?: DropDownListDTO[];
    public listRespValidacao?: DropDownListDTO[];
    public listNumBasica?: DropDownListDTO[];
    public filteredOptionsProduto: Observable<DropDownListDTO[]>;
    public filteredOptionsSiteRecebimento: Observable<DropDownListDTO[]>;
    public filteredOptionsSafra: Observable<DropDownListDTO[]>;
    public filteredOptionsRespValidacao: Observable<DropDownListDTO[]>;
    public filteredOptionsNumBasica: Observable<DropDownListDTO[]>;

    @Output() filter = new EventEmitter();

    constructor(protected formBuilder: FormBuilder, protected formularioService: FormularioService,
        // tslint:disable-next-line: align
        protected notificationService: NotificationService, protected generalService: GeneralService) {
        super();
        this.formulario = this.formBuilder.group({
            cerar: ['', []],
            safra: ['', []],
            contrato_juridico: ['', []],
            produto: ['', []],
            site_recebimento: ['', []],
            resp_validacao: ['', []],
            is_incomplete: ['', []],
            created_at_inicial: ['', []],
            created_at_final: ['', []],
            numero_campo: ['', []]
        });
    }

    async ngOnInit(): Promise<void> {
        this.listProduto = new Array<DropDownListDTO>();
        this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
        this.listRespValidacao = new Array<DropDownListDTO>();
        this.listNumBasica = new Array<DropDownListDTO>();
        await this.getLists();
        await this.getFilters();
    }

    async sendFilter(): Promise<void> {
        this.filter.emit(await this.buildFilter());
    }

    async clearFilter(): Promise<void> {
        this.formulario.reset();
        await this.getFilters();
        this.formulario.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    }

    buildFilter(): FormRs009Filter {
        const formulario: FormRs009Filter = new FormRs009Filter();
        formulario.cerar = this.formulario.get('cerar')?.value ?? '';
        formulario.safra = this.formulario.get('safra')?.value ?? '';
        formulario.contrato_juridico = this.formulario.get('contrato_juridico')?.value ?? '';
        formulario.produto = this.formulario.get('produto')?.value ?? '';
        formulario.site_recebimento = this.formulario.get('site_recebimento')?.value ?? '';
        formulario.numero_campo = this.formulario.get('numero_campo')?.value ?? '';
        formulario.is_incomplete = this.formulario.get('is_incomplete')?.value ?? '';
        formulario.created_at_inicial = !!this.formulario.get('created_at_inicial')?.value ? this.generalService.createDate(this.formulario.get('created_at_inicial')?.value) : null;
        formulario.created_at_final = !!this.formulario.get('created_at_final')?.value ? this.generalService.createDate(this.formulario.get('created_at_final')?.value) : null;
        formulario.resp_validacao = this.formulario.get('resp_validacao')?.value ?? '';
        return formulario;
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListStatus(),
            this.getListProduto(),
            this.getListSafra(),
            this.getListRespValidacao(),
            this.getListNumBasica()
        ]);
    }

    async getListStatus(): Promise<void> {
        this.listStatus = await this.generalService.getListStatus();
    }

    async getListProduto(): Promise<void> {
        await this.formularioService.getList('rs009', 'produto',this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then(response => {
            this.listProduto = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        });
    }

    async getListSafra(): Promise<void> {
        await this.formularioService.getListDropDownList('rs009', 'safra').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSafra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSafra);
        });
    }

    async getListRespValidacao(): Promise<void> {
        await this.formularioService.getList('rs009', 'resp_validacao', this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listRespValidacao = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        });
    }

    async getListNumBasica(): Promise<void> {
        await this.formularioService.getList('rs009', 'numero_campo', this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listNumBasica = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSafra);
        });
    }

    async getFilters(): Promise<void> {
        await Promise.all([
            this.createFilterProduto(),
            this.createFilterSiteRecebimento(),
            this.createFilterSafra(),
            this.createFilterRespValidacao(),
            this.createFilterNumeroBasica()
        ]);
    }

    private createFilterProduto(): void {
        this.filteredOptionsProduto = this.formulario.get('produto').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listProduto, value))
            );
    }

    private createFilterSiteRecebimento(): void {
        this.filteredOptionsSiteRecebimento = this.formulario.get('site_recebimento').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownListSiteRecebimento(this.listSiteRecebimento, value))
            );
    }

    private createFilterSafra(): void {
        this.filteredOptionsSafra = this.formulario.get('safra').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listSafra, value))
            );
    }

    private createFilterRespValidacao(): void {
        this.filteredOptionsRespValidacao = this.formulario.get('resp_validacao').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listRespValidacao, value))
            );
    }

    private createFilterNumeroBasica(): void {
        this.filteredOptionsNumBasica = this.formulario.get('numero_campo').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listNumBasica, value))
            );
    }
}
